<template>
  <div class="dashboard">
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-icon orders">📦</div>
        <div class="stat-info">
          <div class="stat-value">{{ stats.totalOrders }}</div>
          <div class="stat-label">今日订单</div>
        </div>
        <div class="stat-trend up">+12%</div>
      </div>
      <div class="stat-card">
        <div class="stat-icon revenue">💰</div>
        <div class="stat-info">
          <div class="stat-value">{{ stats.totalRevenue }}</div>
          <div class="stat-label">今日营收</div>
        </div>
        <div class="stat-trend up">+8%</div>
      </div>
      <div class="stat-card">
        <div class="stat-icon users">👥</div>
        <div class="stat-info">
          <div class="stat-value">{{ stats.activeUsers }}</div>
          <div class="stat-label">活跃用户</div>
        </div>
        <div class="stat-trend up">+5%</div>
      </div>
      <div class="stat-card">
        <div class="stat-icon runners">🚴</div>
        <div class="stat-info">
          <div class="stat-value">{{ stats.activeRunners }}</div>
          <div class="stat-label">在线跑腿员</div>
        </div>
        <div class="stat-trend down">-2%</div>
      </div>
    </div>

    <div class="charts-section">
      <div class="chart-card">
        <h3>订单趋势</h3>
        <div class="chart-container">
          <canvas id="orderChart"></canvas>
        </div>
      </div>
      <div class="chart-card">
        <h3>服务类型分布</h3>
        <div class="chart-container">
          <canvas id="serviceChart"></canvas>
        </div>
      </div>
    </div>

    <div class="bottom-section">
      <div class="recent-orders">
        <h3>最新订单</h3>
        <table>
          <thead>
            <tr>
              <th>订单号</th>
              <th>服务类型</th>
              <th>金额</th>
              <th>状态</th>
              <th>时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in recentOrders" :key="order.id">
              <td>{{ order.orderNo }}</td>
              <td>{{ getServiceName(order.serviceType) }}</td>
              <td>{{ order.amount }}</td>
              <td><span :class="'status ' + order.status">{{ getStatusName(order.status) }}</span></td>
              <td>{{ order.time }}</td>
              <td><button @click="viewOrder(order.id)">查看</button></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="top-runners">
        <h3>热门跑腿员</h3>
        <ul>
          <li v-for="runner in topRunners" :key="runner.id">
            <div class="runner-info">
              <span class="runner-name">{{ runner.name }}</span>
              <span class="runner-rating">⭐{{ runner.rating }}</span>
            </div>
            <span class="runner-orders">{{ runner.orders }}单</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      stats: {
        totalOrders: 128,
        totalRevenue: 2856.50,
        activeUsers: 456,
        activeRunners: 32
      },
      recentOrders: [
        { id: 1, orderNo: 'DD202605180012', serviceType: 1, amount: 15.50, status: 2, time: '14:35' },
        { id: 2, orderNo: 'DD202605180011', serviceType: 2, amount: 28.00, status: 3, time: '14:20' },
        { id: 3, orderNo: 'DD202605180010', serviceType: 3, amount: 8.00, status: 1, time: '14:15' },
        { id: 4, orderNo: 'DD202605180009', serviceType: 1, amount: 12.00, status: 0, time: '14:10' },
        { id: 5, orderNo: 'DD202605180008', serviceType: 2, amount: 35.00, status: 2, time: '13:55' }
      ],
      topRunners: [
        { id: 1, name: '王师傅', rating: 4.9, orders: 128 },
        { id: 2, name: '张师傅', rating: 4.8, orders: 96 },
        { id: 3, name: '李师傅', rating: 4.7, orders: 85 },
        { id: 4, name: '赵师傅', rating: 4.9, orders: 78 },
        { id: 5, name: '刘师傅', rating: 4.6, orders: 65 }
      ]
    }
  },
  methods: {
    getServiceName(type) {
      const map = { 1: '代送物品', 2: '代买物品', 3: '代取快递', 4: '其他服务' }
      return map[type] || '未知'
    },
    getStatusName(status) {
      const map = { 0: '待接单', 1: '已接单', 2: '进行中', 3: '已完成', 4: '已取消' }
      return map[status] || '未知'
    },
    viewOrder(id) {
      this.$router.push(`/orders/${id}`)
    },
    renderCharts() {
    const orderData = [65, 78, 90, 81, 95, 110, 128]
    const days = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
    
    const serviceData = [45, 30, 20, 5]
    const services = ['代送物品', '代买物品', '代取快递', '其他']

    const renderBarChart = (id, data, labels) => {
      const canvas = document.getElementById(id)
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      const width = canvas.width
      const height = canvas.height
      const padding = 40
      const barWidth = (width - padding * 2) / data.length
      
      ctx.clearRect(0, 0, width, height)
      
      const maxVal = Math.max(...data) * 1.2
      
      data.forEach((val, i) => {
        const barHeight = (val / maxVal) * (height - padding * 2)
        const x = padding + i * barWidth + barWidth / 4
        const y = height - padding - barHeight
        
        ctx.fillStyle = '#3498db'
        ctx.fillRect(x, y, barWidth / 2, barHeight)
        
        ctx.fillStyle = '#666'
        ctx.font = '12px Arial'
        ctx.textAlign = 'center'
        ctx.fillText(labels[i], padding + i * barWidth + barWidth / 2, height - 10)
        ctx.fillText(val.toString(), padding + i * barWidth + barWidth / 2, y - 5)
      })
    }

    const renderPieChart = (id, data, labels) => {
      const canvas = document.getElementById(id)
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      const centerX = canvas.width / 2
      const centerY = canvas.height / 2
      const radius = Math.min(centerX, centerY) - 20
      
      const colors = ['#e74c3c', '#3498db', '#2ecc71', '#f39c12']
      let startAngle = 0
      
      data.forEach((val, i) => {
        const sliceAngle = (val / data.reduce((a,b) => a+b, 0)) * Math.PI * 2
        ctx.beginPath()
        ctx.moveTo(centerX, centerY)
        ctx.arc(centerX, centerY, radius, startAngle, startAngle + sliceAngle)
        ctx.closePath()
        ctx.fillStyle = colors[i]
        ctx.fill()
        startAngle += sliceAngle
      })
      
      ctx.fillStyle = '#fff'
      ctx.beginPath()
      ctx.arc(centerX, centerY, radius / 2, 0, Math.PI * 2)
      ctx.fill()
      
      ctx.fillStyle = '#333'
      ctx.font = '14px Arial'
      ctx.textAlign = 'center'
      ctx.fillText('服务分布', centerX, centerY - 5)
      ctx.fillText(`${data.reduce((a,b) => a+b, 0)}单`, centerX, centerY + 15)
    }

    const orderCanvas = document.createElement('canvas')
    orderCanvas.id = 'orderChart'
    orderCanvas.width = 400
    orderCanvas.height = 200
    document.querySelector('#orderChart')?.replaceWith(orderCanvas)
    renderBarChart('orderChart', orderData, days)

    const serviceCanvas = document.createElement('canvas')
    serviceCanvas.id = 'serviceChart'
    serviceCanvas.width = 300
    serviceCanvas.height = 200
    document.querySelector('#serviceChart')?.replaceWith(serviceCanvas)
    renderPieChart('serviceChart', serviceData, services)
    }
  },
  mounted() {
    this.renderCharts()
  }
}
</script>

<style scoped>
.dashboard {
  padding: 20px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}

.stat-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-right: 15px;
}

.stat-icon.orders { background: #e8f5e9; }
.stat-icon.revenue { background: #fff3e0; }
.stat-icon.users { background: #e3f2fd; }
.stat-icon.runners { background: #fce4ec; }

.stat-info {
  flex: 1;
}

.stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.stat-label {
  font-size: 14px;
  color: #999;
  margin-top: 4px;
}

.stat-trend {
  font-size: 12px;
  font-weight: 500;
}

.stat-trend.up { color: #2ecc71; }
.stat-trend.down { color: #e74c3c; }

.charts-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.chart-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}

.chart-card h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #333;
}

.chart-container {
  display: flex;
  justify-content: center;
}

.bottom-section {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
}

.recent-orders, .top-runners {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}

.recent-orders h3, .top-runners h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #333;
}

.recent-orders table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.recent-orders th, .recent-orders td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.recent-orders th {
  color: #999;
  font-weight: 500;
}

.status {
  padding: 4px 0;
  border-radius: 20px;
  font-size: 12px;
}

.status.0 { background: #fff3e0; color: #f39c12; }
.status.1 { background: #e3f2fd; color: #3498db; }
.status.2 { background: #e8f5e9; color: #2ecc71; }
.status.3 { background: #f5f5f5; color: #666; }

.recent-orders button {
  padding: 5px 12px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.top-runners ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.top-runners li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.top-runners li:last-child {
  border-bottom: none;
}

.runner-info {
  display: flex;
  align-items: center;
}

.runner-name {
  font-weight: 500;
  margin-right: 10px;
}

.runner-rating {
  font-size: 12px;
}

.runner-orders {
  color: #999;
  font-size: 14px;
}
</style>